import type { AuthPermissionUser } from '../../services/authPermissions';

const INVENTORY_OPERATION_ROLES = ['ADMIN', 'OPERATIONS'];

export function canManageInventory(user: AuthPermissionUser | null | undefined): boolean {
  return INVENTORY_OPERATION_ROLES.includes(user?.role || '');
}

export function canGenerateInventoryReports(user: AuthPermissionUser | null | undefined): boolean {
  return user?.canViewSupplierPurchasePrices
    ?? Boolean(user?.role === 'ADMIN' || user?.canViewMargin || user?.canManagePurchaseInvoices);
}
